import React from 'react';
import styled from '@emotion/styled';
import Button from '../../common/Button';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const UnsavedHeaderWrapper = styled('div')`
  height: inherit;
  display: flex;
  align-items: center;
  .unsaved-header-text {
    font-size: 16px;
  }
`;

const UnsavedHeader = (props) => {
  const { handleSubmit, loading, disabled = false } = props;

  const { t } = useAutoTranslation();

  return (
    <UnsavedHeaderWrapper>
      <div className="unsaved-header-text">{t('Изменения не сохранены')}!</div>
      <div style={{ marginLeft: 'auto' }}>
        {!loading ? (
          <button
            className="btn btn btn-light"
            style={{ marginRight: '20px' }}
            onClick={() => document.location.reload()}
          >
            {t('Отменить изменения')}
          </button>
        ) : null}
        <Button
          text={t('Сохранить')}
          onClick={handleSubmit}
          disabled={loading || disabled}
          loading={loading}
        />
      </div>
    </UnsavedHeaderWrapper>
  );
};

export default UnsavedHeader;
